export default {
  ListTab: {
    GeneralInfo: "Thông tin chung",
    RuleAssetCode: "Quy tắc đánh mã tài sản",
    FormatNumber: "Định dạng số",
  },
  GeneralInfo: {
    CompanyName: "Tên công ty",
    Address: "Địa chỉ",
    Phone: "Điện thoại",
    Email: "Email",
    Logo: "Logo",
  },
  RuleAssetCode: {
    Char: "Phần chữ",
    Number: "Phần số",
    WarrningChar:
      "Số ký tự phần chữ trên mã tài sản tự sinh không vượt quá 40 ký tự. Trường hợp nội dung phần chữ quá dài, hệ thống sẽ tự động cắt về 40 ký tự khi sinh mã tài sản.",
  },
  DataComboboxChar: {
    OrganizationUnitCode: "Mã đơn vị quản lý",
    SortCutOrganizationUnit: "Tên viết tắt đơn vị quản lý",
    AssetCategoryCode: "Mã nhóm tài sản",
    AssetTypeCode: "Mã loại tài sản",
    CurrentYear: "Năm hiện tại",
  },
};
